import { Lock, ExternalLink } from "lucide-react";

export const AUTODELETING_URL = "https://www.autodeleting.com/";

export const EncryptedBadge = ({ compact = false, testId = "header-encrypted-badge" }) => (
  <a href={AUTODELETING_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
    title="Connection encrypted (TLS / WSS). For self-destructing encrypted chats use AUTODELETING."
    className="group inline-flex h-9 items-center gap-2 border border-cyan-400/40 bg-cyan-400/5 px-3 font-mono text-[10px] uppercase tracking-widest transition-[border-color,box-shadow] duration-200 hover:border-[color:var(--au-green)] hover:shadow-[0_0_16px_rgba(61,219,232,0.3)]">
    <Lock size={12} className="text-[color:var(--au-green)]" />
    <span className="text-[color:var(--au-green)]">Encrypted</span>
    {!compact && (
      <>
        <span className="hidden text-muted-foreground xl:inline">· Secure chat</span>
        <span className="hidden font-semibold text-foreground sm:inline">AUTODELETING</span>
        <ExternalLink size={11} className="hidden text-muted-foreground transition-colors group-hover:text-foreground sm:inline" />
      </>
    )}
  </a>
);
